export default (hasPriority = false) => {
  return useLocalContext('viewportPriority', () => ({
    hasPriority: ref(hasPriority),
  }))
}
